import React, { useState } from 'react';
import PropTypes from 'prop-types';
import VideoTile from 'components/VideoTile';
import { renderImage } from 'helpers/ImageHelper';
import PlayButton from '../PlayButton';

const Video = ({
  image,
  isHover,
  isNationLicensed,
  play,
  route,
  segmentPlaylistButtonAction,
  seriesName,
  theme,
  video,
  panelId,
  id,
}) => {
  const [initalRender, setInitialRender] = useState(false);
  if (isHover && !initalRender) setInitialRender(true);

  return (
    <div className={theme.videoContainer}>
      <div className={theme.previewContainer}>
        <div className={theme.imageContainer}>
          {initalRender && (
            <span className={!isHover ? theme.invisible : ''}>
              <VideoTile
                data-test="tile-video"
                id={video ? `tile-video-${video}-${panelId}` : undefined}
                image={image}
                load
                loop
                play={play}
                renderImage={renderImage}
                timer={0}
                video={video}
                videoPosterStyle={theme.videoPoster}
              />
            </span>
          )}
        </div>
        <PlayButton
          isNationLicensed={isNationLicensed}
          route={route}
          seriesName={seriesName}
          theme={theme}
          thinIcon
          segmentPlaylistButtonAction={segmentPlaylistButtonAction}
          id={id}
        />
      </div>
      <div className={theme.shadowOverlay} />
    </div>
  );
};

Video.propTypes = {
  image: PropTypes.string,
  isHover: PropTypes.bool,
  isNationLicensed: PropTypes.bool,
  panelId: PropTypes.string,
  play: PropTypes.bool,
  route: PropTypes.string,
  segmentPlaylistButtonAction: PropTypes.func,
  seriesName: PropTypes.string,
  theme: PropTypes.shape({}),
  video: PropTypes.string,
  id: PropTypes.string,
};

Video.defaultProps = {
  image: '',
  isHover: false,
  isNationLicensed: false,
  panelId: '',
  play: false,
  route: null,
  segmentPlaylistButtonAction: () => {},
  theme: {},
  video: null,
  id: null,
};

export default Video;
